import { callApiWithData } from '../../../api/call-api';
import Meal, { mapMealFromApi } from '../../../models/meal';
import MealForm from '../MealForm';
import { callRecipeFromImageApi } from '../../../api/assistant-api';
import { IngredientInputItem } from '../Ingredient/IngredientInput';
import { resolveIngredientIds } from '../../../api/ingredient-api';

interface AddMealProps {
  onMealSave: (meal: Meal) => void;
}

const AddMeal = (props: AddMealProps) => {
  const createMeal = async (
    name: string,
    image: string,
    description: string,
    tastiness: number | null,
    healthiness: number | null,
    ingredients: IngredientInputItem[],
    tags: string[],
    calories: number | null,
    protein: number | null,
    carbs: number | null,
    fat: number | null,
    preparationTime: number | null
  ): Promise<Meal> => {
    const ingredientsPayload = await resolveIngredientIds(ingredients);

    const response = await callApiWithData(
      '/meal',
      {
        name,
        image,
        description,
        tastiness,
        healthiness,
        ...(ingredientsPayload.length > 0 ? { ingredients: ingredientsPayload } : {}),
        tags,
        calories,
        protein,
        carbs,
        fat,
        preparationTime,
      },
      'POST'
    );

    return mapMealFromApi(response.meal);
  };

  const initialDescription =
    '\n' +
    '                            <p>\n' +
    '                                <strong>Ingredience:</strong>\n' +
    '                            </p>\n' +
    '                            <p>\n' +
    '                                <ul>\n' +
    '                                    <li>první ingredience</li>\n' +
    '                                    <li>druhá ingredience</li>\n' +
    '                                </ul>\n' +
    '                            </p>\n' +
    '                            <p>Popis</p>\n' +
    '\n' +
    '                        ';

  return (
    <MealForm
      onMealSave={props.onMealSave}
      submitMeal={createMeal}
      initialName="Název"
      initialDescription={initialDescription}
      initialImage=""
      initialTastiness={null}
      getRecipeFromImage={callRecipeFromImageApi}
    ></MealForm>
  );
};

export default AddMeal;
